import { format } from "../constants";

const formatBreadCrumb = ({ list, path, equivalence = [] }: {
    list: {
        label: string;
        path: string;
    }[]
    path?: string
    equivalence?: string[]
}): {
    label: string;
    path: string;
    active?: boolean
}[] => {
    if (list.length > 0) {
        const newList = list.shift()
        let newListTransformed = [{ label: newList?.label ?? '', path: `${path ?? ''}/${format?.[newList?.path ?? ''] ?? newList?.path}`, active: list.length == 0 }, ...formatBreadCrumb({ list, path: `${path ?? ''}/${newList?.path}` })]

        if (equivalence?.length) {
            let objEquivalence: Record<string, string> = {}

            equivalence.forEach(item => {
                const splitValue = item.split('>')
                objEquivalence = { ...objEquivalence, [splitValue[0]]: splitValue[1] }
            })

            newListTransformed = newListTransformed.map(item => {
                if (objEquivalence[item.label]) {
                    return {
                        ...item,
                        label: objEquivalence[item.label]
                    }
                }
                return item
            })
        }
        return newListTransformed
    }

    return list
}

export { formatBreadCrumb }